export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
};

export const ERROR_CODE = {
  STEP_UP_REQUIRED: "STEP_UP_REQUIRED",
  UNAUTHENTICATED: "UNAUTHENTICATED",
};
